import { useState, useEffect, useRef } from 'react';

type UseFormFocusProps = {
  formErrors: Record<string, unknown> | null | undefined;
};

interface IReturnUseFormFucus {
  setNeedFocus: (value: boolean) => void;
}

const useFormFocus = ({ formErrors }: UseFormFocusProps): IReturnUseFormFucus => {
  const isFirstRender = useRef<boolean>(true);
  const [errorInput, setErrorInput] = useState<HTMLInputElement | null>(null);
  const [needFocus, setNeedFocus] = useState<boolean>(true);

  useEffect(() => {
    const element = document.querySelector('input[aria-invalid=true]');
    if (element && needFocus && formErrors) {
      setErrorInput(element as HTMLInputElement | null);
      setNeedFocus(false);
    }
  }, [formErrors, needFocus]);

  useEffect(() => {
    if (!isFirstRender.current && errorInput) {
      errorInput.setAttribute('tabindex', '0');
      errorInput.focus();
      setErrorInput(null);
    }
    isFirstRender.current = false;
  }, [errorInput]);

  return { setNeedFocus };
};

export default useFormFocus;
